// extracted by mini-css-extract-plugin
module.exports = {"backButton":"BackButton_backButton__1AFVL","light":"BackButton_light__24u8l"};